const AccountState = {
    accounts: [],
    loading: false,
    error:false,
    account: {},
}

export default AccountState;